<template>
    <div class="contact__map">
        <div
            v-if="!isMapVisible"
            class="contact__map-placeholder"
        >
            <div
                class="contact__map-placeholder__image"
                aria-hidden="true"
            />
            <div class="contact__map-placeholder__content">
                <p class="contact__map-placeholder__title">
                    Interaktive Karte
                </p>
                <p class="contact__map-placeholder__text">
                    Zum Anzeigen der Karte ist Ihre Einwilligung erforderlich.
                    Dabei werden Daten an HERE übermittelt.
                </p>
                <button
                    type="button"
                    class="button button--invert contact__map-placeholder__button custom-color-b custom-border-color-b"
                    @click="enableMap"
                >
                    Interaktive Karte anzeigen
                </button>
            </div>
        </div>
        <div
            v-show="isMapVisible"
            ref="container"
            class="contact__map-container"
        />
    </div>
</template>

<script>
import throttle from 'lodash.throttle';
import { eventHub, EVENT_NAMES } from '../../../services/eventService';
import {
    hasUserMapConsentGiven,
    setMapCookie
} from '../../../services/consentService.js';

export default {
    name: 'ContactMap',
    props: {
        hereMapApiKey: {
            type: String,
            default: undefined
        },
        lng: {
            type: String,
            required: true
        },
        lat: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isMapVisible: hasUserMapConsentGiven() === true,
            map: null
        };
    },
    created() {
        this.onMapConsentChanged = (value) => {
            this.isMapVisible = value;
            if (value) {
                this.$nextTick(() => {
                    this.loadMap();
                });
            }
        };
        eventHub.$on(EVENT_NAMES.MAP_CONSENT_CHANGED, this.onMapConsentChanged);
    },
    beforeDestroy() {
        eventHub.$off(EVENT_NAMES.MAP_CONSENT_CHANGED, this.onMapConsentChanged);
    },
    mounted() {
        if (this.isMapVisible) {
            this.$nextTick(() => {
                this.loadMap();
            });
        }
    },
    methods: {
        getPosition() {
            return {
                lat: parseFloat(this.lat, 10),
                lng: parseFloat(this.lng, 10)
            };
        },
        enableMap() {
            setMapCookie(true);
        },
        loadMap() {
            if (this.map || !this.$refs.container) {
                return;
            }

            import(/* webpackChunkName: "here-maps-api" */ '@here/maps-api-for-javascript')
                .then(({ default: H }) => {
                    const position = this.getPosition();
                    const layers = new H.service.Platform({
                        apikey: this.hereMapApiKey
                    }).createDefaultLayers();
                    const map = new H.Map(
                        this.$refs.container,
                        layers.vector.normal.map,
                        {
                            pixelRatio: window.devicePixelRatio,
                            center: position,
                            zoom: 15,
                            imprint: null
                        }
                    );
                    const ui = new H.ui.UI(map, {
                        locale: 'de-DE',
                        scalebar: { alignment: 'bottom-right' },
                        zoom: { alignment: 'right-bottom' }
                    });
                    const infoBubble = new H.ui.InfoBubble(
                        position,
                        { content: this.name }
                    );

                    window.addEventListener('resize', throttle(this.onResize, 700));
                    infoBubble.addClass('contact__map__info-bubble');
                    ui.addBubble(infoBubble);
                    new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
                    this.map = map;
                    map.getViewPort().resize();
                });
        },
        onResize() {
            if (this.map) {
                this.map.getViewPort().resize();
            }
        }
    }
};
</script>
